import fadeIn from '@/scripts/transitions/fadeIn'
import fadeOut from '@/scripts/transitions/fadeOut'
import slide from '@/scripts/transitions/slide'
import sliderEnter from '@/scripts/transitions/sliderEnter'
import sliderOut from '@/scripts/transitions/sliderOut'

const mapTransitions = new Map()

mapTransitions.set('fadeIn', ctx => new Promise((resolve) => { fadeIn(ctx, resolve) }))
mapTransitions.set('fadeOut', fromMenu => new Promise((resolve) => { fadeOut(fromMenu, resolve) }))
mapTransitions.set('slide', (dir, fromMenu) => new Promise((resolve) => { slide(dir, fromMenu, resolve) }))
mapTransitions.set('sliderEnter', firstEnter => new Promise((resolve) => { sliderEnter(firstEnter, resolve) }))
mapTransitions.set('sliderOut', fromMenu => new Promise((resolve) => { sliderOut(fromMenu, resolve) }))

export default mapTransitions



// WEBPACK FOOTER //
// ./src/scripts/mapTransitions.js